import { render } from "./editClientCard.vue?vue&type=template&id=3aa8564a&scoped=true"
import script from "./editClientCard.vue?vue&type=script&lang=js"
export * from "./editClientCard.vue?vue&type=script&lang=js"

import "./editClientCard.vue?vue&type=style&index=0&id=3aa8564a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa8564a"]])

export default __exports__